import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import KTSVG from "../../components/SvgLoader";
import CircularProgress from "../../components/CircularProgress";
import axios from "../../util/Api";
import { Table } from "antd";
import moment from "moment";

const Meetings = () => {
  const intl = useIntl();
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tableLoader, setTableLoader] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [query, setQuery] = useState("");
  const pageLimit = process.env.REACT_APP_TABLE_PAGE_SIZE;

  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Title",
      dataIndex: "topic",
      key: "topic",
    },
    {
      title: "Teacher Name",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "Subject",
      dataIndex: "subject_title",
      key: "subject_title",
    },
    {
      title: "Start Time",
      dataIndex: "date_begin",
      key: "date_begin",
      render: (date_begin) => {
        return moment(date_begin).format("Do MMM, YYYY h:mm A");
      },
    },
    {
      title: "End Time",
      dataIndex: "date_end",
      key: "date_end",
      render: (date_end) => {
        return moment(date_end).format("Do MMM, YYYY h:mm A");
      },
    },
    {
      title: "Join Session",
      render: (data) => {
        return data.session_flag == "1" ? (
          <div className="text-danger">Session Over</div>
        ) : data.session_flag == "2" ? (
          <div className="text-success">Seession yet to start</div>
        ) : data.meeting_flag == "zoom" ? (
          <div className="d-flex align-items-center">
            <a
              className="btn btn-primary"
              href={`${data.zoom_url}`}
              target="_blank"
            >
              Join in Zoom
            </a>
            <div className="ps-2 pe-2">OR</div>
            <a
              className="btn btn-success"
              href={`${data.class_url}`}
              target="_blank"
            >
              Join Class
            </a>
          </div>
        ) : (
          <a
            className="btn btn-success"
            href={`${data.class_url}`}
            target="_blank"
          >
            Join Class
          </a>
        );
      },
    },
  ];

  useEffect(() => {
    setTableLoader(true);
    getData(1, query);
  }, []);

  const getData = (page, query) => {
    axios
      .post(`zoom/list?page=${page}`, { search: query, limit: pageLimit })
      .then(({ data }) => {
        setLoading(false);
        setTableLoader(false);
        if (data.result) {
          setMeetings(data.meetings.data);
          setTotalRecord(data.meetings.total);
        }
      });
  };

  const searchRecord = (query) => {
    setQuery(query);
    if (query.length > 2) {
      setTableLoader(true);
      getData(1, query);
    } else if (query.length == 0) {
      setTableLoader(true);
      getData(1, query);
    }
  };

  const handleTableChange = (pagination) => {
    setTableLoader(true);
    getData(pagination.current, query);
  };

  return (
    <>
      {/* Toolbar Start */}
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
              {intl.formatMessage({ id: "live_classroom" })}
              <span className="h-20px border-gray-200 border-start mx-4"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-dark">
                  {intl.formatMessage({ id: "manage_meetings" })}
                </li>
              </ul>
            </h1>
          </div>
        </div>
      </div>
      {/* Toolbar end */}

      {loading ? (
        <CircularProgress />
      ) : (
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-fluid">
            <div className={`card mb-5 mb-xxl-8 card-xxl-streatch`}>
              <div className="card-header border-0 pt-6">
                <div className="card-title w-100">
                  <div className="w-100">
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginBottom: 20,
                      }}
                    >
                      <h4 className="mb-5">
                        To download the ICSK Connect Windows application, please
                        click on the button below
                      </h4>
                      <a
                        download
                        target="_blank"
                        href={`${process.env.REACT_APP_STORAGE_PATH}/storage/uploads/icskcwa/ICSK-CWA.zip`}
                        className="btn btn-success"
                      >
                        Download ICSK Connect for Windows
                      </a>
                    </div>
                    <div className="d-flex align-items-center position-relative my-1">
                      <span className="svg-icon svg-icon-1 position-absolute ms-6">
                        <KTSVG
                          path="/media/icons/duotone/General/Search.svg"
                          className="svg-icon-1"
                        />
                      </span>

                      <input
                        type="text"
                        data-kt-assignment-table-filter="search"
                        className="form-control form-control-solid w-250px ps-15"
                        placeholder={intl.formatMessage({
                          id: "search",
                        })}
                        onChange={(e) => searchRecord(e.currentTarget.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body pt-5">
                <div className="table-responsive">
                  <Table
                    rowKey={"id"}
                    dataSource={meetings}
                    columns={columns}
                    onChange={handleTableChange}
                    loading={tableLoader}
                    pagination={{
                      total: totalRecord,
                      defaultPageSize: pageLimit,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Meetings;
